import './DemoApp.css';

import React from 'react';
import { Navigate, Route, Routes, useNavigate } from 'react-router-dom';

import DemoAddAthletePage from './pages/DemoAddAthletePage';
import DemoAnnouncementsPage from './pages/DemoAnnouncementsPage';
import DemoExportAthletesPage from './pages/DemoExportAthletesPage';
import DemoJoinPage from './pages/DemoJoinPage';
import DemoTryoutSettingsPage from './pages/DemoTryoutSettingsPage';
import DemoRankAthletesPage from './pages/DemoRankAthletesPage';
import DemoScoreAthletePage from './pages/DemoScoreAthletePage';
import DemoTryoutAthletesPage from './pages/DemoTryoutAthletesPage';
import DemoTryoutPage from './pages/DemoTryoutPage';
import DemoTryoutShell from './pages/DemoTryoutShell';
import { DemoStoreProvider, useDemoStore } from './store/DemoStoreContext';

// Nested under /demo/* in App.tsx. Pages call `navigate('/demo/...')` directly.
const DemoIndexRedirect: React.FC = () => <Navigate to="/demo/join" replace />;

/** Top-right reset: clears localStorage overlay and bounces back to Join. */
const DemoResetButton: React.FC = () => {
  const { resetDemo } = useDemoStore();
  const navigate = useNavigate();
  return (
    <button
      type="button"
      className="demo-reset-btn"
      onClick={() => {
        resetDemo();
        navigate('/demo/join', { replace: true });
      }}
      aria-label="Reset demo"
      title="Reset demo"
    >
      Reset
    </button>
  );
};

const DemoApp: React.FC = () => {
  return (
    <DemoStoreProvider>
      <DemoResetButton />
      <Routes>
        <Route index element={<DemoIndexRedirect />} />
        <Route path="join" element={<DemoJoinPage />} />
        <Route path="tryout" element={<DemoTryoutShell />}>
          <Route index element={<DemoTryoutPage />} />
          <Route path="athletes" element={<DemoTryoutAthletesPage />} />
          <Route path="athletes/:athleteId" element={<DemoScoreAthletePage />} />
          <Route path="add" element={<DemoAddAthletePage />} />
          <Route path="ranking" element={<DemoRankAthletesPage />} />
          <Route path="export" element={<DemoExportAthletesPage />} />
          <Route path="settings" element={<DemoTryoutSettingsPage />} />
          <Route path="announcements" element={<DemoAnnouncementsPage />} />
        </Route>
        <Route path="*" element={<Navigate to="/demo/join" replace />} />
      </Routes>
    </DemoStoreProvider>
  );
};

export default DemoApp;
